import React from 'react';
import classNames from 'classnames';

import {Badge, Text, Menu} from '@albert-io/atomic';

export interface FilterOption {
  label: string;
  value: string | undefined;
}

interface Props {
  label: string;
  selected?: FilterOption | string;
  options: FilterOption[];
  onSelect: (option: FilterOption) => void;
}

const SchoolFilterDropdown = ({label, selected, options, onSelect}: Props) => {
  const hasSelection = typeof selected === 'object' && selected?.value !== undefined;
  const selectedValue = hasSelection ? selected.value : undefined;
  const displayLabel = hasSelection ? selected.label : 'Any';

  return (
    <Menu
      wrapperClassName='mr-x2'
      position='bottom-start'
      positionFixed
      closeOnItemClick
      popperProps={{
        modifiers: {
          flip: {
            enabled: true,
            boundariesElement: 'viewport'
          },
          preventOverflow: {
            boundariesElement: 'viewport'
          }
        }
      }}
    >
      <Menu.Trigger>
        {(triggerProps) => (
          <Badge
            status='info'
            emphasis='subtle'
            icon={['fas', 'chevron-down']}
            iconAlign='right'
            roundness='square'
            {...triggerProps}
          >
            {label}: {displayLabel}
          </Badge>
        )}
      </Menu.Trigger>
      <Menu.Content>
        <div className='max-h-[336px] overflow-y-auto'>
          {options.map((option) => {
            const isSelected = selectedValue === option.value;
            return (
              <Menu.Item
                key={option.label}
                selected={isSelected}
                className={classNames(
                  'justify-start border-0! px-x1-half! py-x1! hover:background-info-subtle!',
                  {'background-info-subtle!': isSelected}
                )}
                onClick={() => onSelect(option)}
              >
                <Text color='inherit'>{option.label}</Text>
              </Menu.Item>
            );
          })}
        </div>
      </Menu.Content>
    </Menu>
  );
};

export default SchoolFilterDropdown;
